import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIButton from 'UIComponents/button/UIButton';
import { PIPELINE_WITH_PERMISSIONS } from 'reference-resolvers-lite/constants/ReferenceTypes';
import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { useHttpClient } from '../../../client/HttpClientContext';
import { useObjectTypeId } from '../../../v2/hooks/useObjectTypeId';
import { useAdditionalPropertyValues } from '../../../v2/hooks/useAdditionalPropertyValues';
import { getPipelinePropertyName, getPipelineStagePropertyName } from '../utils/pipelineUtils';
import PipelineModal from './PipelineModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDataAttributes } from '../../../utils/getDataAttributes';

const PipelineButton = props => {
  const {
    autoFocus,
    className,
    readOnly,
    disabled,
    value,
    onChangeMultiple,
    popoverOpen,
    setPopoverOpen,
    use = 'form',
    truncate = false
  } = props;
  const objectTypeId = useObjectTypeId();
  const httpClient = useHttpClient();
  const pipelineResolver = createStandardCachedResolver(PIPELINE_WITH_PERMISSIONS, objectTypeId, {
    httpClient
  });
  const {
    reference
  } = useFetchResolver(pipelineResolver, value === null ? undefined : value);
  const [pipelineStageId] = useAdditionalPropertyValues([getPipelineStagePropertyName(objectTypeId)]);
  const defaultPipelineId = value === undefined ? null : value;
  const defaultPipelineStageId = pipelineStageId === undefined ? null : pipelineStageId;

  const handleClick = () => setPopoverOpen(true);

  const handleCancel = () => setPopoverOpen(false);

  const handleConfirm = ({
    pipelineId: newPipelineId,
    pipelineStageId: newPipelineStageId,
    closedate
  }) => {
    setPopoverOpen(false);

    if (newPipelineId === defaultPipelineId && newPipelineStageId === defaultPipelineStageId) {
      return;
    }

    const changes = {
      [getPipelinePropertyName(objectTypeId)]: newPipelineId,
      [getPipelineStagePropertyName(objectTypeId)]: newPipelineStageId
    };

    if (closedate) {
      changes['closedate'] = closedate;
    }

    onChangeMultiple(changes);
  };

  const buttonDisplayText = reference && reference.label || value || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputPipelineV2.placeholder"
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, Object.assign({}, getDataAttributes(props), {
      autoFocus: autoFocus,
      className: className,
      disabled: readOnly || disabled,
      onClick: handleClick,
      use: use,
      truncate: truncate,
      children: buttonDisplayText
    })), popoverOpen && /*#__PURE__*/_jsx(PipelineModal, Object.assign({
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      defaultPipelineId: defaultPipelineId,
      defaultPipelineStageId: defaultPipelineStageId
    }, props))]
  });
};

PipelineButton.displayName = 'PipelineButton';
export default PipelineButton;